import axios from "axios";
import { useState, useEffect } from "react";

const apiUrl = process.env.REACT_APP_API_URL;

const useUserRoles = (): { isSuperAdmin: boolean; isAdmin: boolean; loading: boolean } => {
  const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    const checkUserRoles = async () => {
      try {
        interface UserRoleResponse {
          isSuperAdmin: boolean;
          isAdmin: boolean;
        }

        const response = await axios.get<UserRoleResponse>(`${apiUrl}/Admin/isSuperAdmin`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setIsSuperAdmin(response.data.isSuperAdmin);
        setIsAdmin(response.data.isAdmin);
        console.log("Is super admin:", response.data.isSuperAdmin);
        console.log("Is admin:", response.data.isAdmin);
      } catch (error) {
        console.error("Error checking user roles", error);
      } finally {
        setLoading(false);
      }
    };

    checkUserRoles();
  }, [token]);

  return { isSuperAdmin, isAdmin, loading };
};

export default useUserRoles;
